import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

//Clases de equipos
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.codigoClaseEqu}</td>
      <td className=''>{elemento.descrClaseEqu}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfClaseEqu2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a25251501 = autorizacUA.findIndex( autorizac => autorizac === "25251501" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Clases de equipo" btnNuevo={a25251501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '20%'}}>Código</th>
                <th className='' style={{width: '80%'}}>Descripción</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List> 
    </div>
  )
};

export default ConfClaseEqu2
